import {atom} from "recoil"

export const notification_status = atom<any>({
    key : "notification",
    default : {}
})
